import { Card, CardContent } from "@web/components/ui/card";
import { cn, formatCurrency } from "@repo/share-log-web-utils";
import type { StatsSummary } from "@repo/share-log-interfaces";

interface LogSummaryProps {
  summary: StatsSummary;
}

export function LogSummary({ summary }: LogSummaryProps) {
  return (
    <div className="grid grid-cols-3 gap-4">
      <Card>
        <CardContent className="p-4">
          <p className="text-sm text-muted-foreground">총 지출</p>
          <p className="text-xl font-bold text-expense">
            {formatCurrency(summary.totalExpense)}
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <p className="text-sm text-muted-foreground">총 수입</p>
          <p className="text-xl font-bold text-income">
            {formatCurrency(summary.totalIncome)}
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <p className="text-sm text-muted-foreground">잔액</p>
          <p
            className={cn(
              "text-xl font-bold",
              summary.balance >= 0 ? "text-balance" : "text-expense",
            )}
          >
            {formatCurrency(summary.balance)}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
